module.exports = {"id":"51730","name":"Massimo Maccarone","rating":"74","photo":"./data/images/photos/4/51730.png","club":{"name":"Brisbane Roar","logo":"./data/images/clubs/BrisbaneRoar.png"},"positions":["BU"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MassimoMaccarone0.json
// module id = 2847
// module chunks = 0